import { takeEvery, takeLatest } from 'redux-saga/effects';

import { SET_USER_CURRENCY, GET_ALL_CURRENCIES } from './actions';
import { onSetUserCurrency, onGetAllCurrencies } from './effects';

export const setUserCurrencySaga = function* setUserCurrencySaga() {
  yield takeEvery(SET_USER_CURRENCY, onSetUserCurrency);
};

export const getAllCurrenciesSaga = function* getAllCurrenciesSaga() {
  yield takeLatest(GET_ALL_CURRENCIES, onGetAllCurrencies);
};
